import { InMemoryCache } from '@apollo/client';
import { ProfileQueries } from '@minecraft.shared-queries';

const defaultUpdatedProfileField = null;

export const initializeUpdatedProfileFieldState = (cache: InMemoryCache): void => {
  cache.writeQuery({
    query: ProfileQueries.GET_UPDATED_PROFILE_FIELD,
    data: {
      updatedProfileField: defaultUpdatedProfileField,
    },
  });
};

export default {
  resolvers: {
    Mutation: {
      setUpdatedProfileField: (_, { updatedProfileField }, { cache }): null => {
        cache.writeQuery({
          query: ProfileQueries.GET_UPDATED_PROFILE_FIELD,
          data: {
            updatedProfileField,
          },
        });
        return null;
      },
    },
  },
};
